/* Baoba - En mode abonnement: prix courant = prix abonné (lu sur la radio cochée),
   prix barré = prix de référence d'origine, et badge de remise recalculé.
   Seule la carte sélectionnée est modifiée; les autres restent intactes. */
(function () {
  function num(s) {
    if (!s) return NaN;
    var m = String(s).replace(/\s/g, '').match(/[\d.,]+/);
    if (!m) return NaN;
    var n = m[0];
    if (n.indexOf(',') > -1 && n.indexOf('.') > -1) n = n.replace(/\./g, '').replace(',', '.');
    else if (n.indexOf(',') > -1) n = n.replace(',', '.');
    return parseFloat(n);
  }
  function cleanPrice(s) {
    if (!s) return null;
    return s.replace(/\s*[A-Za-z]{2,3}\s*$/, '').replace(/\s+/g, ' ').trim();
  }
  function checkedRadio() {
    var c = document.querySelector('.shopify_subscriptions_app_container');
    if (!c) return null;
    var visible = c.querySelector('section.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)') || c;
    return visible.querySelector('input[type=radio]:checked');
  }
  function allCards() {
    var f = document.querySelector('.baoba-variant-cards');
    return f ? Array.prototype.slice.call(f.querySelectorAll('.baoba-variant-card')) : [];
  }
  function selectedCard() {
    var f = document.querySelector('.baoba-variant-cards');
    if (!f) return null;
    return f.querySelector('.baoba-variant-card.is-selected') || f.querySelector('.baoba-variant-card');
  }

  function restore(card) {
    var priceEl = card.querySelector('.baoba-variant-card__price');
    if (priceEl && priceEl.getAttribute('data-baoba-sub') === '1') {
      var o = priceEl.getAttribute('data-baoba-original');
      if (o !== null) priceEl.innerHTML = o;
      priceEl.removeAttribute('data-baoba-sub');
    }
    if (card.getAttribute('data-baoba-disc-applied') === '1') {
      var disc = card.querySelector('.baoba-variant-card__discount');
      var had = card.getAttribute('data-baoba-disc-had') === '1';
      var origText = card.getAttribute('data-baoba-disc-text') || '';
      if (had) { if (disc) disc.textContent = origText; }
      else { if (disc && disc.parentNode) disc.parentNode.removeChild(disc); }
      card.removeAttribute('data-baoba-disc-applied');
    }
  }

  function apply(card, sub) {
    var priceEl = card.querySelector('.baoba-variant-card__price');
    if (!priceEl) return;
    if (priceEl.getAttribute('data-baoba-original') === null) {
      priceEl.setAttribute('data-baoba-original', priceEl.innerHTML);
    }
    var orig = priceEl.getAttribute('data-baoba-original');

    var tmp = document.createElement('div');
    tmp.innerHTML = orig;
    var compEl = tmp.querySelector('.baoba-variant-card__price-compare');
    var curEl = tmp.querySelector('.baoba-variant-card__price-current');
    var refText = compEl ? compEl.textContent.replace(/\s+/g, ' ').trim()
                : (curEl ? curEl.textContent.replace(/\s+/g, ' ').trim() : null);

    priceEl.innerHTML = '';
    if (refText && refText !== sub) {
      var compare = document.createElement('span');
      compare.className = 'baoba-variant-card__price-compare';
      compare.textContent = refText;
      priceEl.appendChild(compare);
    }
    var current = document.createElement('span');
    current.className = 'baoba-variant-card__price-current';
    current.textContent = sub;
    priceEl.appendChild(current);
    priceEl.setAttribute('data-baoba-sub', '1');

    var refNum = num(refText);
    var subNum = num(sub);
    if (!isNaN(refNum) && !isNaN(subNum) && refNum > 0 && subNum < refNum) {
      var pct = Math.round((refNum - subNum) / refNum * 100);
      var disc = card.querySelector('.baoba-variant-card__discount');
      if (card.getAttribute('data-baoba-disc-applied') !== '1') {
        card.setAttribute('data-baoba-disc-had', disc ? '1' : '0');
        card.setAttribute('data-baoba-disc-text', disc ? disc.textContent : '');
      }
      if (!disc) {
        disc = document.createElement('span');
        disc.className = 'baoba-variant-card__discount';
        card.appendChild(disc);
      }
      disc.textContent = '-' + pct + '%';
      card.setAttribute('data-baoba-disc-applied', '1');
    }
  }

  function sync() {
    var cards = allCards();
    if (!cards.length) return;
    var radio = checkedRadio();
    var isSub = !!(radio && radio.getAttribute('data-radio-type') === 'selling_plan');
    var sel = selectedCard();
    var sub = isSub ? cleanPrice(radio.getAttribute('data-variant-price')) : null;
    cards.forEach(function (card) {
      if (isSub && card === sel && sub) { apply(card, sub); }
      else { restore(card); }
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(sync, 40); }
  function burst() { sync(); setTimeout(sync, 120); setTimeout(sync, 350); setTimeout(sync, 800); }

  document.addEventListener('change', burst, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.shopify_subscriptions_app_container')) burst();
  }, true);

  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 50); return; }
    new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'checked'] });
  }
  startObserver();

  [200, 600, 1200, 2000].forEach(function (d) { setTimeout(sync, d); });
})();
